// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router';
import {Link} from 'react-router-dom';
import {sample} from 'lodash';

// auth
import Layout from '../../shared/components/layout';
import UserSelection from './user-selection';
import UserSignUp from '../containers/user-sign-up';
import EducatorSelection from '../components/educator-selection';
import NotAvailable from './not-available';
import CommunityCollegeSelection from '../components/community-college-selection';
import Eligibility from '../../eligibility/containers/eligibility';

export const SIZE = 55;

export default class SignUp extends React.Component {
  static propTypes = {
    setNavigationAnnouncement: PropTypes.func.isRequired,
    saveUrlParameters: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
  }

  componentDidMount() {
    this.props.setNavigationAnnouncement('Sign Up');
  }

  render() {
    const {
      setNavigationAnnouncement,
      saveUrlParameters,
      history
    } = this.props;

    const splitPath = history.location.pathname.split('/');
    const userSubType = (splitPath.length > 1 && splitPath[2]) || '';

    /* eslint-disable react/jsx-no-bind */
    return (
      <Layout page="signup">
        <div className="auth-signup auth-shared-credentials-container">
          <Switch>
            <Route exact path="/signup" render={(props) => (
              <UserSelection
                {...props}
                setNavigationAnnouncement={setNavigationAnnouncement}
                saveUrlParameters={saveUrlParameters}
                ccSelectionGroupUrl="/signup/cc-student"
              />
            )} />
            <Route path="/signup/check-eligibility" component={Eligibility} />
            <Route exact path="/signup/educator" render={(props) => (
              <EducatorSelection
                {...props}
                setNavigationAnnouncement={setNavigationAnnouncement}
                saveUrlParameters={saveUrlParameters}
              />
            )} />
            <Route exact path="/signup/community-college-selection" render={(props) => (
              <CommunityCollegeSelection
                {...props}
                setNavigationAnnouncement={setNavigationAnnouncement}
                saveUrlParameters={saveUrlParameters}
              />
            )} />
            <Route exact path="/signup/not-available" render={(props) => (
              <NotAvailable
                {...props}
                setNavigationAnnouncement={setNavigationAnnouncement}
                saveUrlParameters={saveUrlParameters}
              />
            )} />
            <Route path="/signup/:userType/:userSubtype" component={UserSignUp} />
            <Route path="/signup/:userType" component={UserSignUp} />
          </Switch>
          <p className="auth-signup-already-have-account">
            Already have an account? <Link to="/login" className="auth-shared-link">Log in</Link>
          </p>
          <p className="auth-signup-already-have-account">
            { userSubType === 'cc-student' &&
              'You can log into your high school account to convert it to a community college account'}
          </p>
        </div>
      </Layout>
    );
    /* eslint-enable */
  }
}
